(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-barre-infos"] && !Shopify.designMode) return;
  try {
    
  /* Défilement des infos sous 750px : un message à la fois, toutes les 4 s.
     Pause au survol, au toucher, au focus, onglet masqué ou bloc sélectionné dans l'éditeur. */
  if (!customElements.get('gc-infos-defile')) {
    class GcInfosDefile extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.gc-infos__item'));
        if (this.items.length < 2) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.pauses = new Set();
        this.index = Math.max(0, this.items.findIndex((item) => item.classList.contains('gc-infos__item--actif')));
        this.relancer = this.relancer.bind(this);
        this.surEntree = () => this.pause('pointeur');
        this.surSortie = () => this.reprendre('pointeur');
        this.surFocus = (event) => {
          const i = this.items.findIndex((item) => item.contains(event.target));
          if (i > -1) this.afficher(i);
          this.pause('focus');
        };
        this.surPerteFocus = (event) => {
          if (!this.contains(event.relatedTarget)) this.reprendre('focus');
        };
        this.surSelection = (event) => {
          const i = this.items.indexOf(event.target);
          if (i < 0) return;
          this.afficher(i);
          this.pause('editeur');
        };
        this.surDeselection = (event) => {
          if (this.items.indexOf(event.target) > -1) this.reprendre('editeur');
        };
        this.addEventListener('pointerenter', this.surEntree);
        this.addEventListener('pointerleave', this.surSortie);
        this.addEventListener('focusin', this.surFocus);
        this.addEventListener('focusout', this.surPerteFocus);
        this.mobile.addEventListener('change', this.relancer);
        document.addEventListener('visibilitychange', this.relancer);
        document.addEventListener('shopify:block:select', this.surSelection);
        document.addEventListener('shopify:block:deselect', this.surDeselection);
        this.relancer();
      }

      disconnectedCallback() {
        if (!this.mobile) return;
        clearTimeout(this.minuteur);
        this.removeEventListener('pointerenter', this.surEntree);
        this.removeEventListener('pointerleave', this.surSortie);
        this.removeEventListener('focusin', this.surFocus);
        this.removeEventListener('focusout', this.surPerteFocus);
        this.mobile.removeEventListener('change', this.relancer);
        document.removeEventListener('visibilitychange', this.relancer);
        document.removeEventListener('shopify:block:select', this.surSelection);
        document.removeEventListener('shopify:block:deselect', this.surDeselection);
      }

      afficher(i) {
        if (i === this.index) return;
        this.items[this.index].classList.remove('gc-infos__item--actif');
        this.index = i;
        this.items[i].classList.add('gc-infos__item--actif');
      }

      pause(raison) {
        this.pauses.add(raison);
        this.relancer();
      }

      reprendre(raison) {
        this.pauses.delete(raison);
        this.relancer();
      }

      relancer() {
        clearTimeout(this.minuteur);
        if (!this.mobile.matches || this.pauses.size > 0 || document.hidden) return;
        this.minuteur = setTimeout(() => {
          this.afficher((this.index + 1) % this.items.length);
          this.relancer();
        }, 4000);
      }
    }

    customElements.define('gc-infos-defile', GcInfosDefile);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.header);
      }

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && (this.predictiveSearch.isOpen || this.predictiveSearch.contains(document.activeElement))) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
